














































































































































import Vue, { VueConstructor } from 'vue'
import BalanceCard from '@/components/BalanceCard.vue'
import ReimbursementsList from '@/components/ReimbursementsList.vue'
import TransactionDetailModal from '@/components/TransactionDetailModal.vue'
import AccountMixin from '../../../../../mixins/accountMixin'
import { mapGetters } from 'vuex'
import { DispatchingService } from '@/api/services/disptachings'
import { CreditLineDeadlineService } from '@/api/services/credit-line-deadline'

interface ComponentData {
  loading: string
  mineColumns: Array<any>
  fnmColumns: Array<any>
  activeTab: string
  rows: any[]
  total: number | undefined
  pagination: {
    page: number
    perPage: number
  }
  selectedTransaction: any
}
export default (Vue as VueConstructor<
  Vue & InstanceType<typeof AccountMixin> & ComponentData
>).extend({
  components: {
    BalanceCard,
    ReimbursementsList,
    TransactionDetailModal
  },

  mixins: [AccountMixin],

  data(): ComponentData {
    return {
      loading: 'none',
      mineColumns: [
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name',
          searchable: true
        },
        {
          label: 'Montant Perçu',
          field: 'totalReceived',
          currency: true
        },
        {
          label: 'Montant Escompté',
          field: 'totalDue',
          currency: true
        },
        {
          label: 'Progression',
          field: 'reimbursementProgress'
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'left'
        }
      ],

      fnmColumns: [
        /* {
          label: 'N° transaction',
          field: 'refundTransaction.reference',
          searchable: true
        }, */
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name',
          searchable: true
        },
        {
          label: 'Montant Remboursé',
          field: 'monthlyAmount',
          currency: true
        },
        {
          label: 'Opérateur mobile',
          field: 'otm'
        },
        {
          label: 'Date/heure',
          field: 'paidAt',
          date: true
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'left'
        }
      ],

      activeTab: 'beneficiary',
      rows: [],
      total: undefined,
      pagination: {
        page: 1,
        perPage: 10
      },
      selectedTransaction: null
    }
  },

  computed: {
    ...mapGetters('product', ['getCurrentProduct']),
    ...mapGetters('auth', ['user']),
    columns(this: any) {
      return this.activeTab === 'beneficiary'
        ? this.mineColumns
        : this.fnmColumns
    },

    isLoading(): boolean {
      return this.loading === this.activeTab
    }
  },

  watch: {
    activeTab(this: any, tab) {
      if (tab === 'beneficiary') {
        this.fetchDispatchings()
      } else if (tab === 'fnm') {
        this.fetchCreditLineDeadlines()
      }
    }
  },

  created(this: any) {
    if (this.$granted('admin|ceo|agencyhead')) {
      this.activeTab = 'beneficiary'
    } else {
      this.activeTab = 'fnm'
    }

    if (this.activeTab === 'beneficiary') {
      this.fetchDispatchings()
    } else {
      this.fetchCreditLineDeadlines()
    }
  },

  methods: {
    onSeeDetails(dispatching: { id: string }) {
      this.$router.push({
        name: 'finances.refunds.group',
        params: { dispatchingId: dispatching.id }
      })
    },

    openTransactionDetail(this: any, deadline: any) {
      this.selectedTransaction = deadline.refundTransaction || {}
    },

    closeTransactionDetail(this: any) {
      this.selectedTransaction = null
    },

    async fetchCreditLineDeadlines(this: any) {
      this.loading = 'fnm'
      try {
        const response = await CreditLineDeadlineService.findAllForRefunds(
          this.user.organizationId,
          this.pagination
        )
        this.rows = response.result
        this.total = response.count
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = 'none'
      }
    },

    async fetchDispatchings(this: any) {
      this.loading = 'beneficiary'
      try {
        const response = await DispatchingService.findAllForRefunds(
          this.pagination
        )
        this.rows = response.result
        this.total = response.count
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = 'none'
      }
    },

    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        if (this.activeTab === 'beneficiary') {
          this.fetchDispatchings()
        } else {
          this.fetchCreditLineDeadlines()
        }
      }
    },

    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        if (this.activeTab === 'beneficiary') {
          this.fetchDispatchings()
        } else {
          this.fetchCreditLineDeadlines()
        }
      }
    }
  }
})
